import { ConnectedLive, usePlayerTimeContext } from '@dicetechnology/doris-ui';

export const Live: React.FC = () => {
    const { atLiveEdge } = usePlayerTimeContext();

    if (!atLiveEdge) {
        return null;
    }

    return <ConnectedLive showLiveDot />;
};
